export default __webpack_public_path__ + "static/media/9.68aa7640.png";